import { render, staticRenderFns } from "./ActivityVideoLooping.vue?vue&type=template&id=7b61bd8a&scoped=true"
import script from "./ActivityVideoLooping.vue?vue&type=script&lang=ts"
export * from "./ActivityVideoLooping.vue?vue&type=script&lang=ts"
import style0 from "./ActivityVideoLooping.vue?vue&type=style&index=0&id=7b61bd8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b61bd8a",
  null
  
)

/* custom blocks */
import block0 from "./ActivityVideoLooping.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports